import { gql } from 'graphql-request'
import { useQuery } from '@/proxy/react-query'
import { client } from '@/proxy/client'
import { timersInMilliseconds } from '@/config/polling'

export const SELLER_USER = gql`
  query sellerUser {
    user {
      role
    }
    seller {
      id
      name
      address {
        city
        number
        street
      }
    }
  }
`

export const SELLER_USER_KEY = 'useSellerUser'

export const useSellerUser = () =>
  useQuery({
    queryKey: [SELLER_USER_KEY],
    queryFn: variables => client.request(SELLER_USER, variables),
    staleTime: timersInMilliseconds.fiveMinutes,
  })
